import React from 'react'

import { twMerge } from 'tailwind-merge'

import { Icon } from '@components/Icon'
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react'

interface AccordionProps {
  title: string
  titleClass?: string
  content: string | React.ReactNode
  open: boolean
}

export const Accordion = ({
  title,
  titleClass,
  content,
  open,
}: AccordionProps) => {
  return (
    <Disclosure
      as={'div' as const}
      defaultOpen={open}
      className="border-t border-grey-soft not-prose"
    >
      <DisclosureButton className="flex items-center justify-between w-full py-[22px]">
        {({ open }: { open: boolean }) => (
          <>
            <h3 className={twMerge('ltr:mr-2 rtl:ml-2 text-left', titleClass)}>
              {title}
            </h3>
            <div
              className={`transform transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`}
            >
              <Icon name="plus" size="13" />
            </div>
          </>
        )}
      </DisclosureButton>
      <DisclosurePanel
        transition
        className="origin-top transition duration-200 ease-out data-[closed]:-translate-y-1 data-[closed]:opacity-0 mt-2 pb-[30px]"
      >
        {typeof content === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        ) : (
          content
        )}
      </DisclosurePanel>
    </Disclosure>
  )
}

export default Accordion
